import DashboardPage from './views/dashboard.page';
import Welcome from './views/welcome';

export default {
  views: {
    DashboardPage,
    Welcome,
  },
};
